const getSortIndex = article => {
  if (!article.acf || !article.acf.sort_index) return null
  return parseInt(article.acf.sort_index)
}

export const sortByIndex = (a, b) => {
  const aIndex = getSortIndex(a)
  const bIndex = getSortIndex(b)

  if (aIndex === null && bIndex === null) {
    return Date.parse(b.published_gmt) - Date.parse(a.published_gmt)
  }

  if (aIndex === null) return 1
  if (bIndex === null) return -1

  return aIndex - bIndex
}
